import React, { useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";

import avatarImg from "../../svg/Avatar.png";
import "./header.css";
import { Button, Group, List, ListItem } from "@mantine/core";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Auth } from "aws-amplify";
import { LogoHcc } from "../../svg/Logo";
import Exit from "../../svg/exit";
import { SettingsIcon } from "../../svg/SettingsIcon";
import LogoInDark from "../../svg/LogoInDark";

import PermissionAction from "../../components/permissions/PermissionAction";
import { BellIcon } from "../../svg/BellIcon";

export function Header({ openNav, setOpenNav }) {
  // const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuthenticator();

  const [isSearchOpen, setSearchOpen] = useState(false);
  const [isInitial, setIsInitial] = useState(true);

  const headerRef = useRef<HTMLDivElement>(null);

  const navigateHome = (e) => {
    e.preventDefault();
    navigate("/");
    setOpenNav(false);
  };
  const navigateTo = (e, path) => {
    e.preventDefault();
    navigate(`/${path}`);
    setOpenNav(false);
  };

  const isHome = window.location.pathname === "/";
  const isBookmark = window.location.pathname === "/bookmarks";
  const isLogs = window.location.pathname === "/log";
  const isReports = window.location.pathname === "/reports";
  const isReportsNew = window.location.pathname === "/reports-new";
  const isUsers = window.location.pathname === "/users";
  const isSettings = window.location.pathname === "/settings";
  const isAlert = window.location.pathname === "/alerts";
  return (
    <>
      <div
        ref={headerRef}
        className=" z-50 w-full h-screen md:h-fit flex flex-col justify-between "
      >
        <div
          className={` relative max-w-[1600px]  flex items-center justify-center md:justify-between py-4 md:flex-row   px-6  sm:px-8 md:mx-auto w-full ${
            openNav ? "flex-col w-full  flex-1 " : "flex-row  w-full "
          }`}
        >
          <div className={`flex items-center flex-row gap-10  `}>
            <div
              className={` ${
                openNav ? "hidden" : "block"
              } md:block cursor-pointer`}
              onClick={navigateHome}
            >
              <LogoHcc />
            </div>
            <IoMdClose
              className="text-4xl absolute right-5 top-6 cursor-pointer md:hidden flex"
              onClick={() => setOpenNav(false)}
            />
            <div className=" absolute left-5 top-5  md:hidden flex">
              <LogoInDark />
            </div>

            <List
              className={`flex list-none md:gap-2 gap-8 items-center    md:flex-row ${
                openNav ? "flex-col" : "flex-row"
              }`}
              withPadding={false}
            >
              <ListItem onClick={navigateHome}>
                <a
                  href="/"
                  className={` sm:text-3xl text-2xl  md:text-md cursor-pointer px-3  rounded-lg no-underline ${
                    isHome
                      ? "text-grayText font-[600]"
                      : "text-grayText2 font-medium "
                  } `}
                >
                  Home
                </a>
              </ListItem>

              <ListItem onClick={(e) => navigateTo(e, "bookmarks")}>
                <a
                  href="/bookmarks"
                  className={`sm:text-3xl text-2xl  md:text-md cursor-pointer px-3  rounded-lg no-underline   ${
                    isBookmark
                      ? "text-grayText font-[600]"
                      : "text-grayText2 font-medium "
                  } `}
                >
                  Bookmarks
                </a>
              </ListItem>
              <PermissionAction operation="R" resource="logs">
                <ListItem onClick={(e) => navigateTo(e, "log")}>
                  <a
                    href="/log"
                    className={`sm:text-3xl text-2xl  md:text-md cursor-pointer px-3  rounded-lg no-underline  ${
                      isLogs
                        ? "text-grayText font-[600]"
                        : "text-grayText2 font-medium "
                    }`}
                  >
                    Audit Logs
                  </a>
                </ListItem>
              </PermissionAction>
              <PermissionAction operation="R" resource="users">
                <ListItem onClick={(e) => navigateTo(e, "users")}>
                  <a
                    href="/users"
                    className={`sm:text-3xl text-2xl  md:text-md cursor-pointer px-3  rounded-lg no-underline  ${
                      isUsers
                        ? "text-grayText font-[600]"
                        : "text-grayText2 font-medium "
                    }`}
                  >
                    Users
                  </a>
                </ListItem>
              </PermissionAction>
              <PermissionAction operation="R" resource="reports">
                <ListItem onClick={(e) => navigateTo(e, "reports")}>
                  <a
                    href="/reports"
                    className={`sm:text-3xl text-2xl  md:text-md cursor-pointer px-3  rounded-lg no-underline  ${
                      isReports
                        ? "text-grayText font-[600]"
                        : "text-grayText2 font-medium "
                    }`}
                  >
                    Reports
                  </a>
                </ListItem>
              </PermissionAction>
              <PermissionAction operation="R" resource="reports">
                <ListItem onClick={(e) => navigateTo(e, "reports-new")}>
                  <a
                    href="/reports-new"
                    className={`sm:text-3xl text-2xl  md:text-md cursor-pointer px-3  rounded-lg no-underline  ${
                      isReportsNew
                        ? "text-grayText font-[600]"
                        : "text-grayText2 font-medium "
                    }`}
                  >
                    Reports New
                  </a>
                </ListItem>
              </PermissionAction>
              <PermissionAction operation="R" resource="reports">
                <ListItem onClick={(e) => navigateTo(e, "alerts")}>
                  <a
                    href="/alerts"
                    className={`sm:text-3xl text-2xl  md:text-md cursor-pointer px-3  rounded-lg no-underline  ${
                      isAlert
                        ? "text-grayText font-[600]"
                        : "text-grayText2 font-medium "
                    }`}
                  >
                    Alerts
                  </a>
                </ListItem>
              </PermissionAction>
            </List>
          </div>

          <div className="relative flex-nowrap items-center gap-6 hidden md:flex">
            <button
              className="flex gap-3 justify-center items-center bg-white border-none  text-xl  md:text-md font-medium"
              onClick={async () => {
                await Auth.signOut();
                signOut();
              }}
            >
              <Exit />
              <span className="text-grayText2">Log out</span>
            </button>
          </div>
        </div>
        <div className="relative flex-nowrap items-center gap-6 flex md:hidden pb-2 md:pb-0">
          <button
            className="flex gap-3 justify-center items-center bg-white border-none  text-md font-medium"
            onClick={async () => {
              await Auth.signOut();
              signOut();
            }}
          >
            <Exit />
            <span className="text-grayText2">Log out</span>
          </button>
        </div>
        <div className="w-full bg-breadCrumbGray2 h-[1px] md:block hidden" />
      </div>
    </>
  );
}

export default Header;
